import disclosure from '../utils/disclosure'

export default {
  provide() {
    return {
      [disclosure]: this,
    }
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },

  data() {
    return {
      items: [],
      activeItem: undefined,
    }
  },

  created() {
    this.$on('created:active', this.createdActive)
    this.$on('created:disclosure', this.createdDisclosure)
  },

  computed: {
    expanded() {
      return this.items.filter(({ expanded }) => expanded)
    },
  },

  methods: {
    createdActive(item) {
      this.activeItem = item
      this.items.forEach((child) => {
        if (child !== item) {
          child.$emit('collapse', item)
        }
      })
    },
    createdDisclosure(item) {
      this.items.push(item)
    },
  },

  render(createElement) {
    return createElement(this.tag, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/components/DisclosureContainer.js